export const BASE_GAIL = process.env.NEXT_PUBLIC_BASE_URL!;
export const BASE_GAIL_CLOUD = process.env.NEXT_PUBLIC_BASE_CLOUD_URL!;
export const BASE_AUTH = process.env.NEXT_PUBLIC_BASE_AUTH_URL!;
export const BASE_SUPPORT_URL = process.env.NEXT_PUBLIC_BASE_SUPPORT_URL!;
export const BASE_MARKETING_URL = process.env.NEXT_PUBLIC_BASE_MARKETING_URL!;
export const BASE_FEEDBACK_URL = process.env.NEXT_PUBLIC_BASE_FEEDBACK_URL!;
export const BASE_METABASE_URL = process.env.NEXT_PUBLIC_BASE_METABASE_URL!;

// Utility function to validate URL format
export const validateUrl = (url: string): boolean => {
  if (!url) return true; // Allow empty URL during typing
  return url.startsWith("http://") || url.startsWith("https://");
};
